import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// Images \\
import Ikea from "../../assets/images/Ikea.svg";
import Ashley from "../../assets/images/Ashley.svg";
import wayfair from "../../assets/images/wayfair.svg";

// Style \\
import "../../assets/styles/sections/brand.scss";

import { Navigation, A11y } from "swiper/modules";

//  $$ Swipper $$ \\
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Brands = () => {
  // const [maxWidth, setMaxWidth] = useState(700);
  // const [maxWidth2, setMaxWidth2] = useState(900);
  // const [minWidth, setMinWidth] = useState(500);
  // useEffect(() => {
  //   setMaxWidth(window.innerWidth);
  //   setMaxWidth2(window.innerWidth);
  // }, [window.innerWidth]);
  // minWidth(window.innerWidth);

  // useEffect(() => {}, [window.innerWidth]);

  // useEffect(() => {}, [window.innerWidth]);

  return (
    <section className="brand">
      <div className="brands">
        <div className="containers">
          <div className="brands_items">
            <div className="brands_items_title mt-[64px] mb-[70px]">
              <div className="title text-center">
                <h3>Brands</h3>
                <p className="w-2/4 mx-auto text-xl">
                  Lorem, ipsum. Lorem, ipsum. Lorem, ipsum.
                </p>
              </div>
            </div>

            <div className="slider mb-[68px]">
              <Swiper
                className="swiper"
                modules={[Navigation, A11y]}
                breakpoints={{
                  992: {
                    spaceBetween: 40,
                    slidesPerView: 5,
                  },
                  768: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                  },
                  576: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                  },
                }}
                navigation
                // pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log("slide change")}
              >
                <SwiperSlide className="SwiperSlide">
                  <img src={Ikea} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={Ashley} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={wayfair} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  {/* <img src={Ikea} alt="nike" /> */}
                  <p>West Elm</p>
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={Ashley} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={wayfair} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={Ikea} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={Ashley} alt="nike" />
                </SwiperSlide>
                <SwiperSlide className="SwiperSlide">
                  <img src={wayfair} alt="nike" />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brands;
